import { useCallback } from 'react';
import { ApolloError } from '@apollo/client/errors';
import {
  CollectorScope,
  useUninstallCollectorMutation,
  useUninstallUserCollectorMutation
} from 'graphql/types';
export const useUninstallCollector = (): {
  uninstallCollector: (
    collectorId: string,
    scope: CollectorScope
  ) => Promise<any>;
  loading: boolean;
  error: ApolloError | undefined;
} => {
  const [
    uninstallCollectorMutation,
    { loading, error }
  ] = useUninstallCollectorMutation();

  const [
    uninstallUserCollectorMutation,
    { loading: userLoading, error: userError }
  ] = useUninstallUserCollectorMutation();

  const uninstallCollector = useCallback(
    async (collectorId: string, scope: CollectorScope) => {
      const input = {
        variables: {
          collectorId
        }
      };

      const mutationMethod =
        scope === CollectorScope.User
          ? uninstallUserCollectorMutation
          : uninstallCollectorMutation;
      return await mutationMethod(input);
    },
    [uninstallCollectorMutation, uninstallUserCollectorMutation]
  );
  return {
    uninstallCollector,
    loading: loading || userLoading,
    error: error || userError
  };
};
